import type { PasskeyCatalog } from './catalog.en.ts';

export const de: PasskeyCatalog = {
  heading: {
    offer: (host: string) => `Auf ${host} künftig ohne Code`,
    done: 'Passkey eingerichtet',
  },
  body: 'Gesicht, Fingerabdruck oder PIN meldet stattdessen an. Der Scan verlässt dieses Gerät nie.',
  status: {
    idle: ' ',
    working: 'Der Abfrage dieses Geräts folgen.',
    done: (host: string) => `Die nächste Anmeldung auf ${host} braucht keinen Code.`,
    error: 'Nicht abgeschlossen — nichts gespeichert.',
  },
  action: {
    idle: 'Passkey einrichten',
    working: 'Passkey einrichten',
    done: 'Fertig',
    error: 'Erneut versuchen',
  },
  decline: 'Jetzt nicht',
  row: {
    idle: 'Kein Passkey auf diesem Gerät',
    working: 'Am Gerät bestätigen',
    done: (host: string) => `Passkey bereit für ${host}`,
    error: 'Abgebrochen — nichts geändert',
  },
  rowAction: {
    idle: 'Einrichten',
    working: 'Einrichten',
    done: 'Ersetzen',
    error: 'Erneut versuchen',
  },
  redo: {
    title: 'Neuen Passkey einrichten?',
    body: (host: string) =>
      `Dieses Gerät hat schon einen für ${host}. Ein neuer ersetzt den, den es zuerst anbietet.`,
    confirm: 'Neuen Passkey einrichten',
    cancel: 'Abbrechen',
  },
  ariaLabel: (host: string) => `Passkey für ${host} einrichten`,
};
